export type SignInput = {
  data: string;
  encoding: {};
};
